import type { Degree, Distance, SpatialRectangle } from "@pdfking/math"
import { Min, Scale, Subtract, Total } from "@pdfking/math"
import type { PathPoint } from "@pdfking/renderer-api"
import { ArcPoints } from "@pdfking/renderer-api"

/** `box` with its corners rounded by `radius`, at most half its shorter
 * side: a pill when it is, a disc when the box is square too. */
export const RoundedRect = (box: SpatialRectangle<Distance>, radius: Distance): PathPoint[] => {
  const r = Min(radius, Scale(box.width, 0.5), Scale(box.height, 0.5))
  const [left, bottom] = [Total(box.x, r), Total(box.y, r)]
  const [right, top] = [Subtract(Total(box.x, box.width), r), Subtract(Total(box.y, box.height), r)]
  // Each corner's quarter, counterclockwise from the bottom right's
  return [
    ...ArcPoints({ x: right, y: bottom }, r, 270 as Degree, 90 as Degree),
    ...ArcPoints({ x: right, y: top }, r, 0 as Degree, 90 as Degree),
    ...ArcPoints({ x: left, y: top }, r, 90 as Degree, 90 as Degree),
    ...ArcPoints({ x: left, y: bottom }, r, 180 as Degree, 90 as Degree),
  ]
}
